import { render, staticRenderFns } from "./Page008.vue?vue&type=template&id=8955114e&scoped=true&"
import script from "./Page008.vue?vue&type=script&lang=js&"
export * from "./Page008.vue?vue&type=script&lang=js&"
import style0 from "./Page008.vue?vue&type=style&index=0&id=8955114e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8955114e",
  null
  
)

export default component.exports